import { formatUnits } from 'ethers/lib/utils'

export const formatBignumberToDecimal = (amount: string, decimals = 18, fractionDigits = 4) =>
  Number(formatUnits(amount, decimals as number).toString()).toFixed(fractionDigits)
